import { render } from "./CreateTask.vue?vue&type=template&id=7b89ace8"
import script from "./CreateTask.vue?vue&type=script&lang=js"
export * from "./CreateTask.vue?vue&type=script&lang=js"

import exportComponent from "/Users/gj/Documents/projects/zwrtwt/zwit-planner/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__